// extracted by mini-css-extract-plugin
export default {"root":"SocialLink_root__LcvJO"};